"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostEndRecrutationUrl = "/EndRecrutation";
//# sourceMappingURL=PostEndRecrutation.js.map